import { Decoder, field, succeed } from 'jsonous';
import { linksDecoder } from '../../Resource/Decoders';
import { TermsAndConditions, TermsAndConditionsResource } from '../Types';

const termsDecoder: Decoder<TermsAndConditions> = succeed({});

export const termsResourceDecoder: Decoder<TermsAndConditionsResource> = succeed({})
  .assign('payload', field('payload', termsDecoder))
  .assign('links', field('links', linksDecoder));
